import { Injectable } from '@angular/core';
import {
  Feed,
  FeedBadgeType,
  FeedOperationalMessageType,
  OperationalMessageWrapper,
  OrdersCountBadge,
} from '../../model/feed.model';
import { Occ } from '../../occ/occ-models';
import { Converter, ConverterService } from '../../util';
import { PRINCIPAL_CONFIGURATION_NORMALIZER } from './converters';

@Injectable({ providedIn: 'root' })
export class FeedNormalizer implements Converter<Occ.Feed, Feed> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.Feed): Feed {
    return source ? this.convertFeed(source) : undefined;
  }

  private convertFeed(source: Occ.Feed): Feed | undefined {
    const configurations = !!source.configurations
      ? this.converter.convertMany(source.configurations, PRINCIPAL_CONFIGURATION_NORMALIZER)
      : undefined;
    const { badges, operationalMessage } = source;
    const feed: Feed = {};
    if (configurations !== undefined) {
      feed.configurations = configurations;
    }
    if (badges !== undefined) {
      feed.badges = this.convertBadges(badges);
    }
    if (operationalMessage !== undefined) {
      feed.operationalMessage = this.convertOperationalMessageWrapper(operationalMessage);
    }
    if (source.lastAreaOfUseSyncStartTime !== undefined) {
      feed.lastAreaOfUseSyncStartTime = source.lastAreaOfUseSyncStartTime;
    }
    if (source.lastAreaOfUseSyncEndTime !== undefined) {
      feed.lastAreaOfUseSyncEndTime = source.lastAreaOfUseSyncEndTime;
    }
    if (source.feedRequestListDTO !== undefined) {
      feed.feedRequestList = source.feedRequestListDTO;
    }
    if (source.hasOngoingSoldToPriceFileRequest !== undefined) {
      feed.hasOngoingSoldToPriceFileRequest = source.hasOngoingSoldToPriceFileRequest;
    }

    return feed;
  }

  private convertBadges(badges: Occ.Badge[]): OrdersCountBadge[] {
    return badges
      ? badges.map((badge) => ({
          type: badge.type as FeedBadgeType,
          count: badge.count,
        }))
      : [];
  }

  private convertOperationalMessageWrapper(operationalMessageWrapper: Occ.OperationalMessageWrapper): OperationalMessageWrapper {
    switch (operationalMessageWrapper.status) {
      case FeedOperationalMessageType.ENABLED:
        return {
          message: {
            bodyMessage: operationalMessageWrapper.message.bodyMessage,
            headerMessage: operationalMessageWrapper.message.headerMessage,
          },
          status: operationalMessageWrapper.status as FeedOperationalMessageType,
        };
      case FeedOperationalMessageType.EMPTY:
        return {
          message: undefined,
          status: operationalMessageWrapper.status as FeedOperationalMessageType,
        };
      case FeedOperationalMessageType.NOT_MODIFIED:
        return {
          message: {},
          status: operationalMessageWrapper.status as FeedOperationalMessageType,
        };

      default:
        return undefined;
    }
  }
}
